import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
var bodyLineHeights = {
  "default": 1.75,
  compact: 1.5
};
/**
 * CSS styles for the type system
 */

export var typePreset = {
  bannerTitle: {
    tag: 'h1',
    style: function style(_ref) {
      var coreTheme = _ref.coreTheme;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [32, 32, 36, 48, 48]
      }, coreTheme), {
        fontFamily: coreTheme.ff_pri_thin,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.1,
        lineHeight: 1.3
      });
    }
  },
  pageTitle: {
    tag: 'h2',
    style: function style(_ref2) {
      var coreTheme = _ref2.coreTheme;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [32, 32, 36, 40, 40]
      }, coreTheme), {
        fontFamily: coreTheme.ff_pri_regular,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.1,
        lineHeight: 1.35
      });
    }
  },
  sectionTitle: {
    tag: 'h3',
    style: function style(_ref3) {
      var coreTheme = _ref3.coreTheme;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [24, 24, 28, 32, 32]
      }, coreTheme), {
        fontFamily: coreTheme.ff_pri_regular,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.1,
        lineHeight: 1.35
      });
    }
  },
  header: {
    tag: 'h4',
    style: function style(_ref4) {
      var coreTheme = _ref4.coreTheme;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [20, 20, 22, 24, 24]
      }, coreTheme), {
        fontFamily: coreTheme.ff_sec_bold,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.1,
        lineHeight: 1.35
      });
    }
  },
  boldBody: {
    tag: 'p',
    style: function style(_ref5) {
      var coreTheme = _ref5.coreTheme,
        lineHeight = _ref5.lineHeight;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [16, 16, 18, 20, 20]
      }, coreTheme), {
        fontFamily: coreTheme.ff_sec_bold,
        color: coreTheme.cl_ter_base,
        lineHeight: bodyLineHeights[lineHeight]
      });
    }
  },
  body: {
    tag: 'p',
    style: function style(_ref6) {
      var coreTheme = _ref6.coreTheme,
        lineHeight = _ref6.lineHeight;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [16, 16, 18, 20, 20]
      }, coreTheme), {
        fontFamily: coreTheme.ff_sec_thin,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.1,
        lineHeight: bodyLineHeights[lineHeight]
      });
    }
  },
  smallBody: {
    tag: 'p',
    style: function style(_ref7) {
      var coreTheme = _ref7.coreTheme,
        lineHeight = _ref7.lineHeight;
      return Object.assign({}, typeReset, responsiveStyles({
        fontSize: [14, 14, 15, 16, 16]
      }, coreTheme), {
        fontFamily: coreTheme.ff_sec_thin,
        color: coreTheme.cl_ter_base,
        letterSpacing: 0.2,
        lineHeight: bodyLineHeights[lineHeight]
      });
    }
  }
};
var LinkComponent = styled.a.withConfig({
  displayName: "style__LinkComponent",
  componentId: "sc-1ngtwew-0"
})(["margin-top:0;margin-bottom:0;font-weight:'unset';letter-spacing:0;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;cursor:pointer;text-decoration:none;", ""], function (p) {
  return Object.assign({}, typePreset.boldBody.style(p), {
    color: p.coreTheme.cl_sec_d1
  });
});
/**
 * Create Styled components using the type system css
 * @type {{}}
 */

export var typeComponents = Object.keys(typePreset).reduce(function (components, typeName) {
  var _typePreset$typeName = typePreset[typeName],
    tag = _typePreset$typeName.tag,
    style = _typePreset$typeName.style;
  var TypeComponent = styled[tag].withConfig({
    displayName: "style__TypeComponent",
    componentId: "sc-1ngtwew-1"
  })(function (p) {
    return css(["", ";", "{font-size:inherit;letter-spacing:inherit;line-height:inherit;}"], style(p), /* sc-selector */
    LinkComponent);
  });
  components[typeName] = withTheme(TypeComponent);
  return components;
}, {});
typeComponents.link = withTheme(LinkComponent);
/**
 * Default styles for typography
 */

var typeReset = {
  marginTop: 0,
  marginBottom: 0,
  fontWeight: 'unset',
  letterSpacing: 0,
  textRendering: 'optimizeLegibility',
  '-webkit-font-smoothing': 'antialiased'
};